import Vue from 'vue';

import UserSettingsPage from './UserSettingsPage.vue';
import ContextSettingsPage from './ContextSettingsPage.vue';

export function registerSettingsPages() {
    Vue.component('UserSettingsPage', UserSettingsPage);
    Vue.component('ContextSettingsPage', ContextSettingsPage);
}
